/**
 * SayzSignature — Modal'ın DIŞINDA, sağ-alt köşede duran lüks "Powered by
 * Sayz" imzası. Tıklayınca yeni sekmede https://sayz.app açılır.
 *
 * Tasarım DNA (minimal luxury, mixed-case editorial):
 *   - Mixed-case: "Powered by Sayz" (uppercase değil, letter-spacing yok)
 *   - "Powered by" → font-normal, opacity 50 (gri hissi)
 *   - "Sayz" → font-bold, opacity 100 (saf beyaz vurgu)
 *   - Tek font-family (parent'tan inherit), tek boyut (11 px) → tipografik
 *     tutarlılık; sadece weight ve opacity ile ayrım
 *   - Hover: "Sayz" kelimesinin altına 1 px beyaz çizgi, 500 ms ease-out
 *     ile soldan sağa doğru yumuşakça çizilir (scale-x origin-left)
 *     "Powered by" ise 50 → 70 opacity (çok hafif canlanır)
 *   - Padding kullanıcı spec: üst 12 px, diğer taraflar sıfır
 */
export const SayzSignature = ({ className = "" }) => (
    <a
        href="https://sayz.app"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sayz-signature"
        aria-label="Powered by Sayz"
        className={`group inline-flex items-baseline gap-1 text-[11px] leading-none tracking-[0.5px] select-none ${className}`}
        style={{ color: "#ffffff" }}
    >
        <span className="opacity-50 font-normal transition-opacity duration-300 group-hover:opacity-70">
            Powered by
        </span>
        <span className="relative inline-block font-bold">
            <span className="relative z-10">Sayz</span>
            <span
                aria-hidden="true"
                className="absolute left-0 -bottom-[2px] w-full h-[1px] origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500 ease-out"
                style={{ background: "#ffffff" }}
                data-sayz-signature-underline
            />
        </span>
    </a>
);

export default SayzSignature;
